import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const HeaderContainer = styled.header`
    background-color: ${theme.colors.primary} !important;
    height: 24px;
    width: 100% !important;
    position: relative;

    @media (min-width: ${theme.breakpoints[2]}) {
        // desktop
        max-width: 664px;
    }

    > img {
        display: block;
        width: 67px;
        height: 16px;
        left: 8px;
        top: 0px;
        position: absolute;
    }

    > button {
        position: absolute;
        right: 16px;
        top: 0px;
        background-color: transparent;
        z-index: 1000;
        width: 18px;
        height: 18px;
        cursor: pointer;
    }
`
